import React from "react"
import {
  InputLabel as MUIInputLabel,
  InputLabelProps as MUIInputLabelProps,
} from "@mui/material"

export type InputLabelProps =
  | ({ new?: false } & MUIInputLabelProps)
  | ({ new: true } & unknown)

export const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>(
  (props, ref) => (props.new ? null : <MUIInputLabel {...props} ref={ref} />),
)

InputLabel.displayName = "InputLabel"

export default InputLabel
